import { useState } from "react";
import { Modal } from "newui/components/ui/Modal";
import { useSkipCompliance } from "newui/features/Rfx/Evaluation/hooks/useCompliance";

export interface SkipComplianceModalProps {
	rfxId: number;
	isOpen: boolean;
	onClose: () => void;
	onConfirmed: () => void;
}

export const SkipComplianceModal = ({
	rfxId,
	isOpen,
	onClose,
	onConfirmed,
}: SkipComplianceModalProps) => {
	const skipMutation = useSkipCompliance(rfxId);
	const [error, setError] = useState<string | null>(null);

	const handleClose = () => {
		if (skipMutation.isPending) {
			return;
		}
		setError(null);
		onClose();
	};

	const handleConfirm = () => {
		setError(null);
		skipMutation.mutate(undefined, {
			onSuccess: () => {
				onConfirmed();
			},
			onError: () =>
				setError(
					"We couldn't skip the compliance check. Please try again."
				),
		});
	};

	return (
		<Modal
			isOpen={isOpen}
			modalType="alert"
			iconType="warning"
			title="Skip compliance check?"
			primaryButton={{
				text: "Confirm",
				btntype: "danger",
				isLoading: skipMutation.isPending,
				onClick: handleConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				disabled: skipMutation.isPending,
				onClick: handleClose,
			}}
			onClose={handleClose}
		>
			<div className="space-y-3 text-sm text-gray-700">
				<p data-testid="skip-compliance-warning">
					All submissions will be marked as compliant and will be
					included in the Evaluation if you proceed.
				</p>

				{error && (
					<p
						className="text-sm text-red-600"
						data-testid="skip-compliance-error"
					>
						{error}
					</p>
				)}
			</div>
		</Modal>
	);
};
